import Echo from 'laravel-echo'
import store from '@/store'

const privateSubscribedChannels = [];
const publicSubscribedChannels = [];

const isChannelSubscribed = (channelName, type = 'private') => {
    const haystack = type === 'private' ?
        privateSubscribedChannels : publicSubscribedChannels;
    return haystack.includes(channelName);
}

export const initLaravelEcho = (host = '', authToken = '') => {
    window.io = require('socket.io-client');
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: host,
        auth: {
            headers: {
                Authorization: "Bearer " + authToken
            }
        }
    });
}

export const updateBearerToken = token => {
    window.Echo.connector.options.auth.headers.Authorization = 'Bearer ' + token;
    if(process.env.NODE_ENV == 'development' ){}
}

export const subscribeToPrivateChannelEvents = (channel = '', events = {}) => {
    console.log('subscribing to private channel: ', channel)
    console.log('to events: ', Object.keys(events).join(','))

    const alreadySubscribed = isChannelSubscribed(channel);
    if(alreadySubscribed){
        console.log(`Private channel ${channel} is currently subscribed`)
        return;
    }

    const subscription = getPrivateLaravelSubscription(channel)

    for (let event in events) {
        subscription.listen(event, events[event])
    }

    privateSubscribedChannels.push(channel);
    console.log(`Private channel ${channel} subscribed`)

}

export const subscribeToPublicChannelEvents = (channel = '', events = {}) => {
    console.log('subscribing to public channel: ', channel)
    console.log('to events: ', Object.keys(events).join(','))

    const subscription = getPublicLaravelSubscription(channel)

    for (let event in events) {
        subscription.listen(event, events[event])
    }

    publicSubscribedChannels.push(channel);
    console.log(`Public channel ${channel} subscribed`)

}

export const whisperOnPrivate = (channel = '', what = '', data = {}) => {
    const subscription = getPrivateLaravelSubscription(channel)
    subscription.whisper(what, data)
}

export const listenPrivateWhisper = (channel = '', what, handler = (data)=>{}) => {
    const subscription = getPrivateLaravelSubscription(channel)

    if(typeof what === 'object'){
        for (let evt in what) {
            subscription.listenForWhisper(evt, what[evt])
        }
    }else{
        subscription.listenForWhisper(what, handler)
    }

}

export const getEchoInstance = () => {

    var echoInstance

    if (!store.state.echoInstance) {
        echoInstance = window.Echo
        store.commit('setLaravelEchoInstance', echoInstance)
    } else {
        echoInstance = store.state.echoInstance
    }

    return echoInstance

}

export const getPrivateLaravelSubscription = (channel = '') => {
    return getEchoInstance().private(channel)
}

export const getPublicLaravelSubscription = (channel = '') => {
    return getEchoInstance().channel(channel)
}

export const leaveChannel = (channel = '') => {

    console.log(`Leaving channel ${channel}...`)

    const privateSubscribed = isChannelSubscribed(channel);
    const publicSubscribed = isChannelSubscribed(channel, 'public');

    if(!privateSubscribed && !publicSubscribed) {
        console.log(`channel ${channel} has not active subscription`)
    }

    if(privateSubscribed){
        const index = privateSubscribedChannels.findIndex(ch => ch === channel);
        if(index !== -1){
            privateSubscribedChannels.splice(index, 1)
        }
    }

    if(publicSubscribed){
        const index = publicSubscribedChannels.findIndex(ch => ch === channel);
        if(index !== -1){
            publicSubscribedChannels.splice(index, 1)
        }
    }

    getEchoInstance().leave(channel)
    console.log(`Channel ${channel} disconnected`)
}
